import { clsx } from 'clsx';
import { FormattedMessage } from 'react-intl';

import messages from './GenericError.messages';
import styles from './GenericError.module.css';
import { ServerErrorIcon } from './ServerErrorIcon';

export const GenericError = ({ className }: { className?: string }) => {
    return (
        <div className={clsx(styles.failurePage, className)}>
            <div className={styles.failureMessage}>
                <div className={styles.failureHeading}>
                    <FormattedMessage {...messages.errorTitle} />
                </div>
                <p>
                    <FormattedMessage {...messages.errorDescription} />
                </p>
            </div>
            <ServerErrorIcon className={styles.failureIcon} />
        </div>
    );
};
